export default __webpack_public_path__ + "static/media/avatarB4.414b0bb1.png";